export const GET_LIST_DANHSACHKHO = "GET_LIST_DANHSACHKHO";
export const GET_LIST_DANHSACHKHO_SUCCESS = "GET_LIST_DANHSACHKHO_SUCCESS";
export const GET_LIST_DANHSACHKHO_FAILURE = "GET_LIST_DANHSACHKHO_FAILURE";
